"use strict";
/*
 * Created on 12. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PriceChangeReportDTO converter.
 *
 * @author SKu
 */


var PriceChangeReportRequestConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceChangeReportRequestConverter, _DataObjectConverter_);

  function PriceChangeReportRequestConverter() {
    _classCallCheck(this, PriceChangeReportRequestConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportRequestConverter).apply(this, arguments));
  }

  return PriceChangeReportRequestConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceChangeReportRequestConverter = PriceChangeReportRequestConverter;